import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

export const usePreviousRoute = (): string | undefined => {
  const router = useRouter();
  const previousPath = useRef<string | undefined>(undefined);

  useEffect(() => {
    const handleRouteChange = (): void => {
      previousPath.current = router.asPath;
    };

    router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router]);

  return previousPath.current;
};
